import { matchPath } from 'react-router-dom';
import { PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

export { default as NavSectionVertical } from './vertical';

export function isExternalLink(path) {
  return path.includes('http');
}

export function getActive(path, pathname) {
  return path && path !== PATH_DASHBOARD.root ? !!matchPath({ path, end: false }, pathname) : false;
}
